import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { AuthService } from '../../core/auth/auth.service';

@Injectable({ providedIn: 'root' })
export class PublicFormGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const isPublic = route.data?.['public'] === true;
    const hasId = !!route.paramMap.get('id');

    if (isPublic && hasId) {
      return true;
    }

    if (!this.authService.getAccessToken()) {
      this.authService.signIn();
      return false;
    }

    return true;
  }
}
